import { SCRAPER_REQUEST_PARAM } from '@decodo/utils';

import { Input } from '@/components/atoms/Input';

import { useScraperTranslations } from '@/blocks/Scraper/scraperTranslations';
import { FormFieldProps } from '@/blocks/Scraper/types';

import ScrapeTargetParamIcon from './ScrapeTargetParamIcon';

const PARAM_PLACEHOLDER_TRANSLATION_IDS: Partial<
  Record<SCRAPER_REQUEST_PARAM, string>
> = {
  [SCRAPER_REQUEST_PARAM.AMAZON_GEO]: 'utils_param_placeholder_amazonGeo',
};

const FormTextField = ({ form, param }: FormFieldProps) => {
  const field = form.getFieldProps(param.key);
  const { getTranslation } = useScraperTranslations();

  const placeholderTranslationId = PARAM_PLACEHOLDER_TRANSLATION_IDS[param.key];
  const placeholder = placeholderTranslationId
    ? getTranslation(placeholderTranslationId) ?? undefined
    : undefined;

  if (placeholderTranslationId && !placeholder) {
    throw new Error(
      `Missing scraper placeholder translation: ${placeholderTranslationId}`
    );
  }

  return (
    <Input
      {...field}
      value={(field.value as string) || ''}
      autoComplete='off'
      tooltip={getTranslation(param.description?.id ?? '')}
      classNames={{
        input: {
          inputElement: 'bg-base-white dark:bg-gray-50',
          root: 'text-gray-950 mb-4',
        },
        tooltip: {
          targetContainer: 'ml-2',
        },
        label: {
          root: 'text-body-l',
        },
      }}
      hideBottomText
      label={getTranslation(param.header.id ?? '')}
      leftIcon={<ScrapeTargetParamIcon param={param} />}
      placeholder={placeholder}
    />
  );
};

export default FormTextField;
